import React from 'react';
import rehypeParse from 'rehype-parse';
import rehypeReact from 'rehype-react';
import { ComponentsWithoutNodeOptions } from 'rehype-react/lib';
import { unified } from 'unified';
import markdownToHtml from './markdown-to-html';

export default function markdownToReact(
  markdown: string,
  components?: ComponentsWithoutNodeOptions['components']
): React.ReactNode {
  // Don't need to sanitize the HTML because micromark handles it
  const html = markdownToHtml(markdown);

  const processor = unified()
    .use(rehypeParse, { fragment: true })
    .use(rehypeReact, {
      createElement: React.createElement,
      Fragment: React.Fragment,
      passNode: false,
      components,
    });

  return processor.processSync(html).result;
}
